import { render, staticRenderFns } from "./EditDescriptionAccount.vue?vue&type=template&id=81864c18"
import script from "./EditDescriptionAccount.vue?vue&type=script&lang=js"
export * from "./EditDescriptionAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81864c18')) {
      api.createRecord('81864c18', component.options)
    } else {
      api.reload('81864c18', component.options)
    }
    module.hot.accept("./EditDescriptionAccount.vue?vue&type=template&id=81864c18", function () {
      api.rerender('81864c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/EditDescriptionAccount.vue"
export default component.exports